import { useState } from "react";

const BrokerTicket = () => {
  const [quantity, setQuantity] = useState(100);
  const [buyPrice] = useState(1.07569);
  const [sellPrice] = useState(1.07561);
  const [buyWhenPrice, setBuyWhenPrice] = useState(false);
  const [closeAtProfit, setCloseAtProfit] = useState(false);
  const [closeAtLoss, setCloseAtLoss] = useState(false);

  return (
    <div className="w-full bg-gray-900 text-white p-4 rounded-lg">
      <div className="flex justify-between items-center mb-4">
        <div>
          <span className="text-xs font-semibold">EUR/USD</span>
          <p className="text-1.5xs text-gray-400">Forex</p>
        </div>
      </div>

      <div className="flex justify-around bg-gray-800 rounded-lg p-2 mb-4">
        <div className="flex flex-col items-center">
          <span className="text-1.5xs text-gray-400">Buy</span>
          <span className="text-green-400 font-semibold">{buyPrice}</span>
        </div>
        <div className="flex flex-col items-center">
          <span className="text-1.5xs text-gray-400">Sell</span>
          <span className="text-gray-200 font-semibold">{sellPrice}</span>
        </div>
      </div>

      <div className="text-1.5xs text-gray-400 mb-2">
        <span>Spread</span> <span className="float-right text-white">0.00008</span>
      </div>

      <div className="flex items-center bg-gray-800 rounded-lg mb-4 p-2">
        <input
          type="number"
          value={quantity}
          onChange={(e) => setQuantity(e.target.value)}
          className="w-full bg-gray-800 text-white text-xs outline-none px-2"
        />
        <span className="text-1.5xs text-gray-400">Euro</span>
      </div>

      <div className="flex justify-between items-center mb-2">
        <span className="text-1.5xs text-gray-400">Buy when the price is</span>
        <input
          type="checkbox"
          checked={buyWhenPrice}
          onChange={() => setBuyWhenPrice(!buyWhenPrice)}
          className="form-checkbox text-green-400"
        />
      </div>

      <div className="text-1.5xs text-gray-400 mb-2">
        <span>Margin required</span> <span className="float-right text-white">€3.33</span>
      </div>

      <div className="text-1.5xs text-gray-400 mb-4">
        <span>Available</span> <span className="float-right text-white">€12,162.54</span>
      </div>

      <div className="flex justify-between items-center mb-2">
        <span className="text-1.5xs text-gray-400">Close at profit</span>
        <input
          type="checkbox"
          checked={closeAtProfit}
          onChange={() => setCloseAtProfit(!closeAtProfit)}
          className="form-checkbox text-green-400"
        />
      </div>

      <div className="flex justify-between items-center mb-4">
        <span className="text-1.5xs text-gray-400">Close at loss</span>
        <input
          type="checkbox"
          checked={closeAtLoss}
          onChange={() => setCloseAtLoss(!closeAtLoss)}
          className="form-checkbox text-green-400"
        />
      </div>

      <button className="w-full bg-green-500 text-white py-2 rounded-lg font-semibold mb-4">
        Buy {buyPrice}
      </button>

      <div className="flex justify-between text-1.5xs text-gray-400 mb-2">
        <div>
          <p>Min. Quantity</p>
          <p className="text-white">100</p>
        </div>
        <div>
          <p>Leverage</p>
          <p className="text-white">1:30</p>
        </div>
        <div>
          <p>Dynamic Spread</p>
          <p className="text-white">0.00008</p>
        </div>
      </div>

      <div className="text-1.5xs text-gray-400">
        <span>Initial margin</span> <span className="float-right text-white">3.33%</span>
      </div>
    </div>
  );
};

export default BrokerTicket;
